{
  "de": {
    "headlines": {
      "vehiclePlaque": {
        "title": "Widmungstafel"
      },
      "vehicleOverview": {
        "paints": "%{model}-Lackierungen",
        "location": "Wo steht das Schiff?",
        "picture": "Schiffsbild"
      },
      "vehicleLog": {
        "create": "Neuer Logbucheintrag",
        "edit": "Logbucheintrag bearbeiten",
        "public": "Logbuch: %{vehicle}"
      },
      "hangarShare": "Freigabelink",
      "locations": {
        "index": "Orte",
        "places": "Alle Orte"
      },
      "admin": {
        "locations": {
          "index": "Orte"
        },
        "blueprints": {
          "index": "Baupläne",
          "materials": "Materialien",
          "stats": "Werte",
          "sources": "Quellen"
        },
        "missions": {
          "index": "Missionen"
        },
        "dashboard": {
          "title": "Dashboard",
          "visitsPerDay": "Besuche pro Tag",
          "visitsPerMonth": "Besuche pro Monat",
          "mostViewedPages": "Meistbesuchte Seiten",
          "registrationsPerMonth": "Registrierungen pro Monat"
        },
        "models": {
          "index": "Modelle",
          "edit": {
            "index": "Modell bearbeiten",
            "fleetchart": "Flottenkarten-Bilder",
            "positions": "Besatzungspositionen",
            "hardpoints": "Aufhängungspunkte",
            "cargoAndFuel": "Fracht & Treibstoff",
            "cargoHolds": "Frachträume",
            "metrics": "Metriken",
            "prices": "Preise",
            "docks": "Andockplätze",
            "modules": "Module",
            "paints": "Lackierungen",
            "videos": "Videos",
            "images": "Bilder",
            "itemPrices": "Artikelpreise",
            "linkModule": "Vorhandenes Modul verknüpfen",
            "loaners": "Leihschiffe",
            "snubCrafts": "Snub Crafts",
            "upgrades": "Upgrades",
            "packages": "Pakete",
            "linkUpgrade": "Vorhandenes Upgrade verknüpfen",
            "history": "Verlauf"
          },
          "new": "Neues Modell",
          "show": "Modell",
          "images": "Bilder",
          "tableConfigurationModal": "Tabellenkonfiguration"
        },
        "components": {
          "index": "Komponenten",
          "new": "Neue Komponente",
          "edit": {
            "index": "Komponente bearbeiten",
            "itemPrices": "Artikelpreise",
            "history": "Verlauf"
          }
        },
        "modelPaints": {
          "index": "Lackierungen",
          "new": "Neue Lackierung",
          "edit": "Lackierung bearbeiten",
          "copy": "Lackierung auf Schiff kopieren",
          "bulkCopy": "%{count} Lackierungen auf Schiff kopieren"
        },
        "modelModules": {
          "index": "Module",
          "new": "Neues Modul",
          "edit": "Modul bearbeiten",
          "models": "Verknüpfte Modelle",
          "prices": "Preise",
          "hardpoints": "Aufhängungspunkte",
          "docks": "Andockplätze",
          "cargoHolds": "Frachträume",
          "history": "Verlauf"
        },
        "unlistedModels": {
          "index": "Schiffe in den Spieldateien ohne Model",
          "link": "Mit einem Schiff im Katalog verknüpfen"
        },
        "manufacturers": {
          "index": "Hersteller",
          "new": "Neuer Hersteller",
          "edit": {
            "index": "Hersteller bearbeiten"
          }
        },
        "announcements": {
          "index": "Ankündigungen",
          "new": "Neue Ankündigung",
          "edit": "Ankündigung bearbeiten",
          "deliveries": "Zustellung",
          "manualPosts": "Beiträge zum Kopieren"
        },
        "supporterContributions": {
          "index": "Unterstützer-Beiträge",
          "new": "Neuer Beitrag",
          "edit": "Beitrag bearbeiten",
          "perMonth": "Beiträge pro Monat"
        },
        "fundingGoals": {
          "index": "Finanzierungsziele",
          "new": "Neues Finanzierungsziel",
          "edit": "Finanzierungsziel bearbeiten"
        },
        "users": {
          "index": "Benutzer",
          "edit": "Benutzer bearbeiten",
          "fleets": "Flotten",
          "inventories": "Inventare",
          "supporterContributions": "Unterstützer-Beiträge"
        },
        "vehicles": {
          "index": "Fahrzeuge",
          "edit": "Fahrzeug bearbeiten"
        },
        "fleets": {
          "index": "Flotten",
          "edit": "Flotte bearbeiten",
          "members": "Mitglieder",
          "memberEdit": "Mitglied bearbeiten",
          "history": "Verlauf",
          "roles": "Rollen",
          "inventories": "Inventare",
          "inventoryItems": "Einträge"
        },
        "fleetFidClaims": {
          "index": "Ansprüche auf Flotten-IDs"
        },
        "destroyedFleets": {
          "index": "Gelöschte Flotten"
        },
        "admins": {
          "index": "Administratoren",
          "new": "Neuer Administrator",
          "edit": "Administrator bearbeiten"
        },
        "oauthApplications": {
          "index": "OAuth-Anwendungen",
          "new": "Neue OAuth-Anwendung",
          "edit": "OAuth-Anwendung bearbeiten",
          "reject": "%{name} ablehnen",
          "rejectBulk": "%{count} Anwendungen ablehnen"
        },
        "features": {
          "index": "Feature-Flags",
          "show": "Funktionsdetails",
          "globalState": "Globaler Status",
          "groups": "Gruppen",
          "actors": "Akteure",
          "selfService": "Self-Service",
          "percentageOfActors": "Prozent der Akteure",
          "percentageOfTime": "Prozent der Zeit",
          "addActor": "Akteur hinzufügen",
          "history": "Verlauf",
          "addUser": "Für einen Benutzer aktivieren",
          "addFleet": "Für eine Flotte aktivieren",
          "enabledUsers": "Aktivierte Benutzer",
          "enabledFleets": "Aktivierte Flotten"
        },
        "rsiApiStatus": {
          "index": "RSI-API-Status"
        },
        "images": {
          "index": "Bilder"
        },
        "imports": {
          "index": "Importe"
        },
        "notifications": {
          "index": "Benachrichtigungen"
        },
        "commodities": {
          "index": "Commodities",
          "edit": {
            "index": "Edit Commodity"
          }
        },
        "equipment": {
          "index": "Equipment",
          "edit": {
            "index": "Edit Equipment",
            "itemPrices": "Item Prices"
          }
        },
        "visualTests": {
          "index": "Visuelle Tests",
          "notifications": "Benachrichtigungen"
        },
        "buildCompare": {
          "index": "Build-Vergleich"
        }
      },
      "welcome": "Willkommen auf",
      "welcomeShips": "Latest Ships",
      "welcomeImages": "Random Images",
      "ships": {
        "index": "Ships Index",
        "fleetchart": "Schiffe Flottenübersicht"
      },
      "images": "Images Index",
      "stats": "Statistiken",
      "notFound": "Navigationsfehler",
      "forbidden": "Zugriff verweigert",
      "subscriptionRequired": "Unterstützer-Funktion",
      "featureNotReady": "Demnächst",
      "inviteInvalid": "Ungültiger Einladungslink",
      "accessDenied": "Zugriff verweigert",
      "serverError": "Serverfehler",
      "offline": "Verbindung verloren",
      "invalidRequest": "Ungültige Anfrage",
      "comments": "Kommentare",
      "login": "Anmelden",
      "hangar": {
        "index": "Mein Hangar",
        "preview": {
          "title": "Dein Hangar",
          "lead": "Behalte jedes Schiff im Blick, das du besitzt — kostenlos mit einem FleetYards.net-Konto."
        },
        "alternativeNames": "Alternative Namen",
        "stats": "Statistiken",
        "public": "%{user} Hangar",
        "import": "Importieren",
        "wishlist": "Wunschliste",
        "publicStats": "Statistiken",
        "publicWishlist": "%{user} Wunschliste",
        "resetIngame": "Ingame-Schiffe nach Wipe zurücksetzen",
        "buybacks": "Rückkauf-Pledges",
        "paints": "Lackierungen",
        "flair": "Hangar-Flair",
        "upgrades": "Upgrades / CCUs",
        "equipment": "FPS-Ausrüstung",
        "shipComponents": "Schiffskomponenten",
        "imports": "Importe"
      },
      "buybackSync": "RSI-Rückkauf-Pledges synchronisieren",
      "syncExtension": "RSI-Hangar synchronisieren",
      "editMyVehicle": "Edit my %{vehicle}",
      "vehicleLoadout": "Loadout für %{vehicle}",
      "nameMyVehicle": "Name my %{vehicle}",
      "editGroups": "Edit Groups",
      "newVehicles": "Add Ships",
      "myVehicleAddons": "Add Modules / Upgrades for %{vehicle}",
      "myVehicleLoadouts": "Loadouts für %{vehicle}",
      "addToHangar": "Add \"%{model}\" to your Hangar",
      "impressum": "Impressum",
      "privacy": "Datenschutzerklärung",
      "cookie": "Cookie policy",
      "requestPassword": "Passwort anfordern",
      "changePassword": "Passwort ändern",
      "confirmAccess": "Confirm access",
      "setEmail": "E-Mail-Adresse festlegen",
      "oauthAuthorize": "Anwendung autorisieren",
      "filterModels": "Filter Ships",
      "filterVehicles": "Filter Hangar",
      "fleets": {
        "directory": "Flottenverzeichnis",
        "owners": "Owners",
        "add": "Create a new Fleet",
        "invites": "Flotteneinladungen",
        "inviteUrls": "Invite Urls",
        "members": {
          "index": "Members",
          "worldmap": "Mitglieder-Weltkarte",
          "starmap": "Mitglieder-Sternenkarte",
          "health": "Mitglieder-Zustand"
        },
        "squadrons": {
          "index": "Staffeln",
          "create": "Staffel anlegen",
          "edit": "Staffel bearbeiten",
          "formDetails": "Details",
          "formAppearance": "Erscheinungsbild",
          "formDiscord": "Discord",
          "ranks": "Staffelränge",
          "editMember": "Staffelmitglied bearbeiten",
          "editRank": "Staffelrang bearbeiten",
          "teams": "Teams",
          "addMembers": "Mitglieder hinzufügen",
          "members": "Mitglieder"
        },
        "stats": "Statistiken",
        "preview": {
          "title": "Deine Flotte",
          "lead": "Bring deine Org zusammen — kostenlos mit einem FleetYards.net-Konto."
        },
        "settings": {
          "fleet": "Fleet Settings",
          "rsi": "Flotten-ID & RSI",
          "membership": "Membership Settings",
          "roles": "Flottenrollen",
          "squadrons": "Staffeln der Flotte",
          "allies": "Verbündete der Flotte",
          "notifications": "Benachrichtigungseinstellungen",
          "inAppNotifications": "In-App-Benachrichtigungen",
          "discord": "Discord",
          "calendar": "Kalender",
          "contracts": "Auftragseinstellungen",
          "features": "Flottenfunktionen"
        },
        "inviteMember": "Invite new Member",
        "calendarSubscription": "Kalender-Abonnement",
        "missions": {
          "index": "Missionen",
          "create": "Mission erstellen",
          "edit": "Mission bearbeiten",
          "editDetails": "Details",
          "editDescription": "Beschreibung & Titelbild",
          "editTeams": "Teams & Slots",
          "teams": "Teams",
          "ships": "Schiffe",
          "slots": "Slots",
          "addTeam": "Team hinzufügen",
          "editTeam": "Team bearbeiten",
          "addShip": "Schiff hinzufügen",
          "editShip": "Schiff bearbeiten"
        },
        "events": {
          "expandShip": "Sitze hinzufügen",
          "index": "Events",
          "calendar": "Kalender",
          "create": "Event erstellen",
          "edit": "Event bearbeiten",
          "editDetails": "Details",
          "editSchedule": "Termin",
          "editSignup": "Anmeldung",
          "editDescription": "Beschreibung & Titelbild",
          "editTeams": "Teams & Slots",
          "spawn": "Event aus Mission erstellen",
          "details": "Event-Details",
          "schedule": "Zeitplan",
          "settings": "Einstellungen",
          "lifecycle": "Lebenszyklus",
          "signupTitle": "Ich bin dabei",
          "yourSignup": "Deine Anmeldung",
          "spawnedFrom": "Aus dieser Mission erstellt",
          "pickTemplate": "Missionsvorlage auswählen",
          "unassignedSignups": "Nicht zugewiesene Anmeldungen",
          "eventTeam": "Event-Team",
          "grantRole": "Rolle vergeben",
          "editTeam": "Team bearbeiten",
          "addTeam": "Team hinzufügen",
          "editShip": "Schiff bearbeiten",
          "addShip": "Schiff hinzufügen",
          "assignSlotFor": "Slot für %{username} zuweisen",
          "reassignSlotFor": "Slot für %{username} neu zuweisen"
        },
        "memberNickname": "Spitzname des Mitglieds",
        "editRole": "Rolle bearbeiten",
        "contracts": {
          "index": "Aufträge",
          "create": "Auftrag erstellen",
          "edit": "Auftrag bearbeiten",
          "progress": "Fortschritt",
          "crew": "Crew",
          "items": "Waren",
          "editItem": "Waren bearbeiten",
          "addItem": "Waren hinzufügen",
          "views": {
            "open": "Aufträge",
            "closed": "Beendete Aufträge",
            "mine": "Meine Aufträge",
            "completed": "Abgeschlossene Aufträge"
          }
        }
      },
      "hangarGroup": {
        "create": "Create Group",
        "edit": "Edit Group"
      },
      "compare": {
        "ships": "Schiffe vergleichen"
      },
      "settings": {
        "account": "Konto",
        "profile": "Profileinstellungen",
        "hangar": "Hangar-Einstellungen",
        "privacy": "Datenschutz-Einstellungen",
        "privacySections": {
          "analytics": "Nutzungsanalyse",
          "onlineStatus": "Online-Status",
          "supporters": "Unterstützerseite"
        },
        "features": "Feature-Flags",
        "connections": "Verbindungen",
        "oauthApplications": "OAuth-Anwendungen",
        "notifications": "Benachrichtigungseinstellungen",
        "verify": "Verify your RSI Account",
        "security": {
          "index": "Kontosicherheit",
          "twoFactor": "Two-factor Authentication"
        },
        "twoFactor": {
          "enable": "Enable Two-factor Authentication",
          "disable": "Disable Two-factor Authentication",
          "backupCodes": "Generate Two-Factor Backup Codes"
        },
        "calendar": "Kalender-Abonnement",
        "donations": "Spenden"
      },
      "oauthApplications": {
        "new": "Neue OAuth-Anwendung",
        "edit": "OAuth-Anwendung bearbeiten"
      },
      "roadmap": "Schiff-Roadmap",
      "tools": {
        "index": "Werkzeuge",
        "travelTimes": "Reisezeiten",
        "cargoGrids": "Frachtraster",
        "tradeRoutes": "Handelsrouten"
      },
      "rsiVerification": "Verify your RSI-Account",
      "support": "Support FleetYards.net",
      "supporters": "Danke an unsere Unterstützer",
      "appUpdate": "Eine neue Version ist verfügbar",
      "installApp": {
        "offer": "Nimm FleetYards mit",
        "ios": "FleetYards installieren"
      },
      "supportHint": {
        "hangarSync": "Schön, dass dir der Sync hilft",
        "vehicleAdded": "Dein Hangar wächst",
        "fleetCreated": "Neue Flotte — gratuliere!",
        "loginMilestone": "Schön, dass du wieder da bist",
        "visitMilestone": "Gefällt dir FleetYards?"
      },
      "vehicle": {
        "bulkGroupEdit": "Gruppen hinzufügen/entfernen"
      },
      "pagination": {
        "count": "%{current} von %{total}"
      },
      "models": {
        "index": "Modelle"
      },
      "modals": {
        "models": {
          "displayOptions": "Anzeigeoptionen"
        }
      },
      "visualTests": {
        "overview": "Übersicht",
        "panels": "Bereiche",
        "buttons": "Schaltflächen",
        "media": "Medien",
        "charts": "Diagramme",
        "blueprints": "Baupläne",
        "squadrons": "Staffeln",
        "alerts": "Hinweise",
        "verifiedBadges": "Verifizierungsabzeichen",
        "chips": "Visuelle Tests Chips",
        "events": "Events",
        "typography": "Typografie",
        "forms": "Formulare",
        "tables": "Tabellen",
        "lists": "Listen",
        "metrics": "Metriken",
        "states": "Zustände",
        "notifications": "Benachrichtigungen",
        "dedicationPlaques": "Widmungstafeln",
        "syncModal": "Sync-Modal",
        "buybackSyncModal": "Rückkauf-Sync-Modal",
        "rsiVerificationModal": "RSI-Verifizierungs-Modal",
        "fleetRsiVerificationModal": "Flotten-RSI-Verifizierungs-Modal",
        "overlays": "Overlays",
        "installPrompt": "Installationshinweis",
        "supportHint": "Support-Hinweis",
        "notificationCenter": "Benachrichtigungszentrale",
        "themes": "Themes"
      },
      "logistics": {
        "index": "Logistics",
        "inventories": "Inventories",
        "requests": "Requests",
        "newRequest": "New Request",
        "requestItems": "Items",
        "comments": "Comments",
        "inventoryItems": "Inventory Items",
        "createInventory": "Create Inventory",
        "editInventory": "Edit Inventory",
        "createItem": "Add Item",
        "deposit": "Deposit",
        "withdrawal": "Withdrawal",
        "importCsv": "Import from CSV",
        "hangarInventories": "Hangar Inventare",
        "editItem": "Eintrag bearbeiten",
        "editStockItem": "Edit Item",
        "transfer": "Bestand transferieren",
        "transfers": "Transfers",
        "acceptTransfer": "Transfer annehmen",
        "pickItem": "Gegenstand wählen",
        "crafting": "Herstellung",
        "reportTransfer": "Transfer melden"
      },
      "notifications": {
        "index": "Benachrichtigungen"
      },
      "payouts": {
        "index": "Auszahlungen",
        "summary": "Übersicht",
        "participants": "Teilnehmer",
        "entries": "Einträge",
        "balances": "Salden",
        "transfers": "Auszahlungsliste",
        "addEntry": "Geld erfassen",
        "editEntry": "Eintrag bearbeiten",
        "addParticipant": "Teilnehmer hinzufügen",
        "tours": {
          "index": "Touren",
          "create": "Tour erstellen",
          "join": "Dieser Tour beitreten"
        },
        "declineExpense": "Ausgabe ablehnen"
      },
      "relationships": {
        "user": {
          "index": "Freunde",
          "add": "Freund hinzufügen"
        },
        "fleet": {
          "add": "Verbündeten hinzufügen"
        }
      },
      "fleet": {
        "contractCovers": "Auftrags-Titelbilder"
      },
      "component": {
        "temperature": "Temperatur",
        "misfire": "Fehlfunktion",
        "history": "Historie",
        "craftedFrom": "Herstellbar aus",
        "identity": "Details",
        "metrics": "Werte",
        "requiredTags": "Passt in einen Port mit",
        "tags": "Tags",
        "physical": "Physische Werte",
        "damageTaken": "Erlittener Schaden",
        "durability": "Haltbarkeit",
        "selfRepair": "Selbstreparatur",
        "distortion": "Distortion",
        "splineJump": "Orbitsprung"
      },
      "commodity": {
        "priceHistory": "Preisverlauf",
        "identity": "Details",
        "usedIn": "Verwendet in"
      },
      "commodities": {
        "index": "Handelswaren"
      },
      "components": {
        "index": "Komponenten"
      },
      "blueprints": {
        "index": "Baupläne"
      },
      "missions": {
        "index": "Missionen"
      },
      "missions": {
        "index": "Missionen"
      },
      "equipment": {
        "index": "Ausrüstung",
        "metrics": "Werte",
        "identity": "Details",
        "craftedFrom": "Herstellbar aus"
      }
    }
  }
}
